module.exports = __webpack_public_path__ + "static/media/kh.a3798580.png";